import { useTranslation } from "react-i18next";
import { Navbar, Header, Footer, MarkdownParser } from "../components";

import { styles } from "../styles";
import { useQuery } from "@tanstack/react-query";
import customAxios from "../utils/customAxios";
import ErrorPage from "./ErrorPage";
import { GenericMarkdownLoadingSkeleton } from "../components/LoadingSkeleton";
const TentangPage = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const { data, isLoading, isError } = useQuery({
    queryKey: ["universityProfiles"],

    queryFn: async () => {
      const response = await customAxios.get("university-profiles");

      return response?.data?.data || null;
    },
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });

  if (isError) {
    return (
      <ErrorPage
        code="500"
        titleKey="error.500_title"
        defaultTitle="Gagal Memuat Data"
        subtitleKey="error.500_subtitle"
        defaultSubtitle="Terjadi masalah saat terhubung ke server kami. Silakan coba lagi nanti atau kembali ke"
      />
    );
  }

  const renderMarkdown = () => {
    if (isLoading) return <GenericMarkdownLoadingSkeleton />;
    if (!data) return null;

    const { content_en, content_id } = data[0] || {};
    return (
      <MarkdownParser
        content={currentLanguage === "en" ? content_en : content_id}
      />
    );
  };

  return (
    <>
      <Navbar />
      <Header title={t("about.header")} />
      <main className={`${styles.paddingX} w-full py-20`}>
        <section className="mx-auto max-w-[1152px]">{renderMarkdown()}</section>
      </main>
      <Footer />
    </>
  );
};

export default TentangPage;
